import React from "react";

export function CardSkeleton({ variant = "default" }) {
  const aspect = variant === "list" ? "aspect-[4/3]" : "aspect-[16/10]";
  return (
    <div className="animate-pulse">
      <div className={`w-full ${aspect} bg-softblue/50`} />
      <div className="mt-3 h-3 w-24 bg-softblue/50" />
      <div className="mt-2 h-4 w-full bg-softblue/60" />
      <div className="mt-2 h-4 w-3/4 bg-softblue/50" />
    </div>
  );
}

export function GridSkeleton({ count = 4, columns = 4 }) {
  const gridCls = {
    2: "grid-cols-1 sm:grid-cols-2",
    3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
    4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4",
  }[columns] || "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4";
  return (
    <div className={`grid ${gridCls} gap-6`}>
      {Array.from({ length: count }).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  );
}

export function HeroSkeleton() {
  return (
    <div className="animate-pulse w-full aspect-[16/9] bg-softblue/40" />
  );
}
